import { Navigation } from '@efast_public/fjd-component-library';
import { useMatch, useNavigate } from 'react-router-dom';

import { RoutePaths } from '../../pages/AppRoutes';
import useTabs from '../../shared/hooks/useTabs';

export function MainNavigation() {
  const navigate = useNavigate();
  // Also highlight Antragsübersicht on the home route so the button is active right after login
  const antraegeMatch = useMatch(RoutePaths.ANTRAEGE);
  const homeMatch = useMatch(RoutePaths.HOME);
  const casesPageMatch = antraegeMatch || homeMatch;
  const schreibtischPageMatch = useMatch(`${RoutePaths.SCHREIBTISCH}*`);
  const { activeTab } = useTabs();
  const activeTabId =
    activeTab && activeTab?.id !== 'empty' ? activeTab?.id : '';

  return (
    <Navigation>
      <Navigation.NavigationItem
        selected={!!casesPageMatch}
        icon="table-split"
        label={'Antragsübersicht'}
        onClick={() => navigate(RoutePaths.ANTRAEGE)}
      />

      <Navigation.NavigationItem
        selected={!!schreibtischPageMatch}
        icon="edit"
        label={'Schreibtisch'}
        onClick={() => navigate(`/schreibtisch/${activeTabId}`)}
      />
    </Navigation>
  );
}
